import { Icon, Person } from "dyl-components";
import { Label } from "semantic-ui-react";

const SelectionRender = ({ value, onChange }) => {
    const onDeleteAccess = (_, id) => {
        onChange(_, value.filter(selectedAccess => selectedAccess.id !== id));
    };

    const onRemoveAll = (_) => {
        onChange(_, []);
    };

    return (
        <div className="BannerDisplay__AccountSelection">
            <div className="BannerDisplay__AccountSelection__Selected">
                {value.map(user => (
                    <div key={user.id} className="SelectedAccounts">
                        <Label className="SelectedAccounts__Label" basic>
                            <Person
                                username={user?.name}
                                email={`ID: ${user?.id}`}
                            />

                            <Label.Detail>
                                <Icon
                                    className="fa-solid fa-xmark"
                                    onClick={_ => onDeleteAccess(_, user.id)}
                                />
                            </Label.Detail>
                        </Label>
                    </div>
                ))}
            </div>

            {value.length > 0 && (
                <div className="BannerDisplay__AccountSelection__RemoveAll">
                    <span onClick={onRemoveAll}>
                        Remove all selected
                    </span>
                </div>
            )}
        </div>
    );
};

export default SelectionRender;